import sdl from '@jds/react-generated-sdl/JDSBadgeV2Status';
import type { JDSBadgeV2StatusProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic } from '../logic';

const Component = (props: JDSBadgeV2StatusProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    kind = 'icon',
    size = 'xtra-large',
    status = 'success',
    border = false,
    ariaLabel = props.label?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    { kind, size, status, border, ariaLabel, ...rest },
    'JDSBadgeV2Status',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const BadgeV2Status = withLogic(
  Component
) as React.FC<JDSBadgeV2StatusProps> & { slotName?: string };

BadgeV2Status.displayName = 'BadgeV2Status';
BadgeV2Status.slotName = 'jds_badge_v_2_status';

export { BadgeV2Status, type JDSBadgeV2StatusProps };
